export default __webpack_public_path__ + "static/media/feature3.97d1ec34.webp";